interface IVAT_UAE_FORMULA {
  sale: number;
  rate: number;
  inclusiveVAT: number;
}

export const VAT_UAE_FORMULA = ({
  sale,
  rate,
  inclusiveVAT,
}: IVAT_UAE_FORMULA) => {
  const valueSale = Number(sale);
  const vatRateValue = Number(rate);
  const vatInc = Number(inclusiveVAT);

  if (valueSale < 100 || valueSale > 1e6) {
    const res = 0;
    return {
      saleValue: res.toFixed(2),
      vatAmount: res.toFixed(2),
      totalValue: res.toFixed(2),
    };
  }
  const vatRate = vatRateValue / 100;
  const amount =
    vatInc === 1 ? valueSale * vatRate : valueSale * (vatRate / (1 + vatRate));
  const netSale = vatInc === 1 ? valueSale : valueSale - amount;
  const totValue = netSale + amount;
  return {
    saleValue: netSale.toFixed(2),
    vatAmount: amount.toFixed(2),
    totalValue: totValue.toFixed(2),
  };
};
